import React, { Fragment, PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import event, { EVENTS } from '../../lib/event.js';
import { connect } from 'react-redux';
import styles from './style.css';
import header from './head.png';
import xiaoao from './shutup.gif';
import StepsCardLineText from './steps-card-line-text';
import StepsCardLineImg from './steps-card-line-image';
import StepsCardLineVideo from './steps-card-line-video';
import ChatBtns from './chat-buttons'
import StepCardLineOption from './steps-card-line-options';

class StepsCardLines extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            // 'onDrag',
            // 'handleStop',
            // 'showTips'
        ]);
    }

    componentDidMount() {
        const chatBox = document.getElementById('chatList');
        this.timer = setInterval(() => {
            if(chatBox){
                chatBox.scrollTop = chatBox.scrollHeight
            }
        }, 300);
        chatBox.addEventListener('scroll',()=>{
            setTimeout(()=>{
                clearInterval(this.timer)
            },2500)
        })
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }


    render() {
        const { cardContent, stepLast, cardLast,user,mode } = this.props;

        return (
            <div>
                {
                    cardContent.reply ? (
                        <div className={styles.chatItemRight}>
                            <div className={styles.chatContentRight}>
                                {
                                    cardContent.lines.map((item, i) => (
                                        <Fragment key={JSON.stringify(item)}>
                                            {
                                                item.hasOwnProperty('text') && <StepsCardLineText stepLast={stepLast} cardLast={cardLast} contentText={item} />
                                            }
                                            {
                                                item.hasOwnProperty('image') && <StepsCardLineImg contentImg={item} />
                                            }
                                            {
                                                item.hasOwnProperty('video') && <StepsCardLineVideo contentVideo={item} />
                                            }
                                            {
                                                item.hasOwnProperty('button') && <StepCardLineOption option={item} />
                                            }
                                            {
                                                item.hasOwnProperty('buttons') && <ChatBtns cardButton={item.buttons} mode={mode} stepLast={stepLast} />
                                            }
                                        </Fragment>
                                    ))
                                }
                            </div>
                            <div className={stepLast && cardLast ? styles.chatAllBody : styles.chatOnlyHead}>
                                <img src={window.config.staticURL + '/avatar/' + (user.avatar || 'default.png')}></img>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.chatItem}>
                            <div className={stepLast && cardLast ? styles.chatAllBody : styles.chatOnlyHead}>
                                <img src={stepLast && cardLast ? xiaoao : header}></img>
                            </div>
                            <div className={styles.chatContent}>
                                {
                                    cardContent.lines.map((item, i) => (
                                        <Fragment key={JSON.stringify(item)}>
                                            {
                                                item.hasOwnProperty('text') && <StepsCardLineText stepLast={stepLast} cardLast={cardLast} contentText={item} />
                                            }
                                            {
                                                item.hasOwnProperty('image') && <StepsCardLineImg contentImg={item} />
                                            }
                                            {
                                                item.hasOwnProperty('video') && <StepsCardLineVideo contentVideo={item} />
                                            }
                                            {
                                                item.hasOwnProperty('button') && <StepCardLineOption option={item} />
                                            }
                                            {
                                                item.hasOwnProperty('buttons') && <ChatBtns cardButton={item.buttons} btnType='blue' mode={mode} stepLast={stepLast} />
                                            }
                                        </Fragment>
                                    ))
                                }
                            </div>
                        </div>
                    )
                }

            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.teach.user
});


export default connect(
    mapStateToProps
)(StepsCardLines);
